import React, { useState } from 'react'
import { Post } from '../../web_api/api'
import { Link } from 'react-router-dom'
import { FiChevronRight } from 'react-icons/fi'
import Swal from 'sweetalert2'
import '../../branch/branch.css'

const PAGES = ['Home', 'About Us', 'Our Services', 'Promos', 'Testimonials', 'Activities', 'Blog', 'Contacts']

export default function BannerCreate() {
    const [files, setFiles] = useState([])
    const [previews, setPreviews] = useState([])
    const [page, setPage] = useState('')
    const [description, setDescription] = useState('')

    const handleFiles = (e) => {
        const selected = Array.from(e.target.files).slice(0, 5)
        setFiles(selected)
        setPreviews(selected.map(f => URL.createObjectURL(f)))
    }

    const create = async () => {
        if (files.length === 0) {
            Swal.fire({ title: 'Need Image!', text: 'Try again!', icon: 'error', showConfirmButton: false, timer: 2000 })
            return
        }
        const formData = new FormData()
        files.forEach(f => formData.append('banners', f))
        formData.append('page', page)
        formData.append('description', description)
        await Post('/banner-photos', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/treatment-dashboard'>Banners</Link>
                <FiChevronRight className='separator' size={14} />
                <span className='current'>Create Banner</span>
            </div>

            <div className='branch-page-title'>Create Banner</div>
            <div className='branch-page-subtitle'>Add a new banner image</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Banner Details</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label'>
                                        Image <span className='required'>*</span>
                                    </label>
                                    <input type='file' multiple accept='image/*' className='branch-input' onChange={handleFiles} />
                                </div>
                                {previews.length > 0 && (
                                    <div className='d-flex flex-wrap gap-2 mt-2'>
                                        {previews.map((src, i) => (
                                            <img key={i} src={src} alt={`preview ${i}`} style={{ width: 100, height: 100, objectFit: 'cover' }} />
                                        ))}
                                    </div>
                                )}
                                <div className='branch-field'>
                                    <label className='branch-field-label'>Page</label>
                                    <select className='branch-input' value={page} onChange={e => setPage(e.target.value)}>
                                        <option value=''>Select Page</option>
                                        {PAGES.map(p => <option key={p} value={p}>{p}</option>)}
                                    </select>
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label'>Description</label>
                                    <textarea className='branch-input' value={description} onChange={e => setDescription(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='branch-form-footer'>
                        <Link to='/treatment-dashboard' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={create}>Create</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
